import { SubjectEnum } from '@shared/services/teachers/enums';
export enum FirstLessonRedirectType {
  PAYMENT = 'payment',
  PAYMENT_IN_PROGRESS = 'payment_in_progress',
  CHANGE_TEACHER = 'change_teacher',
  NOTHING_TO_PAY = 'nothing_to_pay',
}

export interface FirstLessonRedirectPaymentDto {
  type: FirstLessonRedirectType.PAYMENT;
  paymentLink: string;
}

export interface FirstLessonRedirectPaymentInProgressDto {
  type: FirstLessonRedirectType.PAYMENT_IN_PROGRESS;
}

export interface FirstLessonRedirectChangeTeacherDto {
  type: FirstLessonRedirectType.CHANGE_TEACHER;
  studentId: string;
  workingClass: string | null;
  subject: SubjectEnum | null;
}

export interface FirstLessonRedirectNothingToPayDto {
  type: FirstLessonRedirectType.NOTHING_TO_PAY;
}

export type FirstLessonRedirectDto =
  | FirstLessonRedirectPaymentDto
  | FirstLessonRedirectPaymentInProgressDto
  | FirstLessonRedirectChangeTeacherDto
  | FirstLessonRedirectNothingToPayDto;
